import { render, staticRenderFns } from "./JsonFormBoolean.vue?vue&type=template&id=571e9bcd&scoped=true"
import script from "./JsonFormBoolean.vue?vue&type=script&lang=ts"
export * from "./JsonFormBoolean.vue?vue&type=script&lang=ts"
import style0 from "./JsonFormBoolean.vue?vue&type=style&index=0&id=571e9bcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e9bcd",
  null
  
)

export default component.exports